<template>
    <customer-layout>
      <template #header>
              <h2 class="text-xl font-semibold leading-tight text-white">
                  Create company
              </h2>
          </template>
          <span v-if="message.length > 0" class="font-bold error-notice" >   {{ message }} </span>

          <div class="pt-8 mb-16">
            <span v-if="error.length > 0" class="font-bold error-notice" >   {{ error }} </span>
            <span v-if="message.length > 0" class="font-bold error-notice" >   {{ message }} </span>

              <form @submit="companySubmit">
                  <!-- <slot></slot> -->

                  <div class="grid gap-4 lg:grid-cols-12">
                      <!-- first column start -->
                      <div class="lg:col-span-7">
                          <!-- cover image -->
                          <div class="mb-4 bg-white border rounded-md shadow-lg">
                              <div class="p-7">
                                  <h4 class="text-2xl font-semibold">Cover</h4>
                                  <p class="text-xs text-gray-500">Carica l'immagine in formato jpg o png o webp.
                                      Dimensioni
                                      consigliate 1600 x 500 pixel.</p>
                                  <div class="w-full my-6 border-b-2 border-gray-100"></div>
                                  <div>
                                      <label
                                          class="flex flex-col items-center w-full p-4 uppercase bg-white border rounded-lg cursor-pointer hover:bg-gray-300">
                                          <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 20 20">
                                              <path
                                                  d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                                          </svg>
                                          <span class="mt-2 text-base">Sostituisci immagine</span>
                                          <input type="file" name="cover_image" id="cover_image" class="hidden" ref="file"
                                              @change="onCoverChange">
                                          <img v-bind:src="coverImagePreview" style="width:8rem; height:8rem;"
                                              v-show="coverShowPreview" />
                                      </label>
                                      <span v-if="messageImage.length > 0" class="font-bold error-notice"> {{ messageImage
                                          }}
                                      </span>
                                  </div>
                              </div>
                          </div>
                          <!-- data -->
                          <div class="mb-4 bg-white border rounded-md shadow-lg">
                              <div class="p-7">
                                  <h4 class="text-2xl font-semibold">Dati</h4>
                                  <div class="w-full my-6 border-b-2 border-gray-100"></div>
                                  <ValidationProvider name="name" rules="required" :bails="false"
                                      v-slot="{ classes, errors }">
                                      <label for="name">Nome Azienda:</label>
                                      <input type="text"
                                          class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                          name="name" v-model="name" :class="classes" />
                                      <span class="text-xs font-bold error-notice">{{ errors[0] }}</span>
                                  </ValidationProvider>
  
                                  <div class="grid grid-cols-3 gap-4">
                                      <div class="col-span-2">
                                          <ValidationProvider name="taxcode" rules="required|check_vat:11" :bails="false"
                                              v-slot="{ classes, errors }">
                                              <label for="description">Partita IVA</label>
                                              <input type="text"
                                                  class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                                  name="p_iva" v-model="p_iva" minlength="11" maxlength="11"
                                                  :class="classes" />
                                              <span class="text-xs font-bold error-notice">{{ errors[0] }}</span>
                                          </ValidationProvider>
                                      </div>
                                      <div>
                                          <label for="description">SDI/PEC</label>
                                          <input type="text"
                                              class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                              name="sdi_cod" v-model="sdi_cod" />
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <!-- description -->
                          <div class="mb-4 bg-white border rounded-md shadow-lg">
                              <div class="p-7">
                                  <h4 class="text-2xl font-semibold">Descrizione</h4>
                                  <div class="w-full my-6 border-b-2 border-gray-100"></div>
                                  <label for="mission">Mission</label>
                                  <vue-editor v-model="mission" name="mission"
                                      placeholder="Descrivi l'azienda e i 5 prodotti di punta, utilizzando le parole chiave che li caratterizzano."></vue-editor>
                              </div>
                          </div>
                      
                          <!-- Address -->
                          <div class="mb-4 bg-white border rounded-md shadow-lg">
                              <div class="p-7">
                                  <h4 class="text-2xl font-semibold">Indirizzo</h4>
                                  <div class="w-full my-6 border-b-2 border-gray-100"></div>
  
                                  <label for="address">Indirizzo:</label>
                                  <input type="text"
                                      class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                      name="address" v-model="address" />
  
  
                                  <div class="grid gap-4" :class="region !== '' ? ' lg:grid-cols-4' : ' lg:grid-cols-3'">
                                      <div>
                                          <label for="city">Città:</label>
                                          <input type="text"
                                              class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                              name="city" v-model="city" />
                                      </div>
                                      <div>
                                          <label for="region">Regione:</label>
                                          <div class="w-full p-2 text-black bg-white border border-gray-300 rounded-md">
                                              <select class="w-full focus:outline-none" name="region" v-model="region"
                                                  @change="filterProvince(region)">
                                                  <option></option>
                                                  <option v-for="region_id in region_id" :key="region_id.id"
                                                      :value="region_id.id">{{ region_id.name }}</option>
                                              </select>
                                          </div>
                                      </div>
                                      <div v-if="region !== ''">
                                          <label for="province">Provincia:</label>
                                          <div class="w-full p-2 text-black bg-white border border-gray-300 rounded-md">
                                              <select class="w-full focus:outline-none" name="province"
                                                  v-model="province">
                                                  <option disabled selected value=0>select province</option>
                                                  <option v-for="province_id in provinces" :key="province_id.id"
                                                      :value="province_id.id">
                                                      {{ province_id.name }}
                                                  </option>
                                              </select>
                                          </div>
                                      </div>
                                      <div>
                                          <label for="zip_code">CAP:</label>
                                          <input type="text"
                                              class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                              name="zip_code" v-model="zip_code" />
                                      </div>
                                  </div>
                                  <label>Filiali</label>
                                  <input type="checkbox" v-model="branches" name="branches">
                                  <div v-if="branches"
                                      class="w-full p-2 mb-3 overflow-y-scroll text-black bg-white border border-gray-300 rounded-md "
                                      style="height:8rem;">
                                      <ul class="w-full focus:outline-none">
                                          <li v-for="branch in regions" :key="branch.id">
                                              <label :for="branch.id">
                                                  <input type="checkbox" name="branch" :id="branch.id"
                                                      v-model="companyBranches" :value="branch.id">
                                                  {{ branch.name }}
                                              </label>
                                          </li>
                                      </ul>
                                  </div>
  
                              </div>
                          </div>
                          <!-- summary -->
                          <div class="mb-4 bg-white border rounded-md shadow-lg">
                              <div class="p-7">
                                  <h1 class="text-2xl font-semibold">Riepilogo</h1>
                                  <div class="w-full my-6 border-b-2 border-gray-100"></div>
                                  <textarea v-model="summary" name="summary" id="summary" cols="5" rows="4"
                                      class="w-full p-4 border-2 border-gray-300 rounded-md focus:outline-none"
                                      @input="textLimit"></textarea>
                                  <span v-if="limitMessage.length > 0" class="text-sm font-semibold text-red-600">{{
                  limitMessage }}</span>
                              </div>
                          </div>
                      </div>
                      <!-- first column end -->
  
                      <!-- second column start -->
                      <div class="lg:col-span-5">
                         
                          <!-- logo -->
                          <div class="mb-4 bg-white border rounded-md shadow-lg">
                              <div class="p-7">
                                  <h4 class="text-2xl font-semibold">Logo</h4>
                                  <p class="text-xs text-gray-500">Carica il logo in formato jpg o png o webp. Dimensioni
                                      consigliate 500 x 500 pixel.</p>
                                  <div class="w-full my-6 border-b-2 border-gray-100"></div>
                                  <div>
                                      <label
                                          class="flex flex-col items-center w-full p-4 uppercase bg-white border rounded-lg cursor-pointer hover:bg-gray-300">
                                          <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 20 20">
                                              <path
                                                  d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                                          </svg>
                                          <span class="mt-2 text-base">Sostituisci immagine</span>
                                          <input type="file" name="logo" id="logo" class="hidden" ref="file1"
                                              @change="onLogoChange">
                                          <img v-bind:src="logoImagePreview" style="width:8rem; height:8rem;"
                                              v-show="logoShowPreview" />
                                      </label>
                                      <span v-if="messageLogo.length > 0" class="font-bold error-notice"> {{ messageLogo
                                          }}
                                      </span>
                                  </div>
                              </div>
                          </div>
                          <!-- contacts -->
                          <div class="mb-4 bg-white border rounded-md shadow-lg">
                              <div class="p-7">
                                  <h4 class="text-2xl font-semibold">Contatti</h4>
                                  <div class="w-full my-6 border-b-2 border-gray-100"></div>
                                  <label for="site_url">Sito Web</label>
                                  <input type="text"
                                      class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                      name="site_url" v-model="site_url" />
  
                                  <ValidationProvider name="email" rules="email_check" :bails="false"
                                      v-slot="{ classes, errors }">
                                      <label for="email">Email</label>
                                      <input type="email"
                                          class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                          name="email" v-model="email" :class="classes" />
                                      <span class="text-xs font-bold error-notice">{{ errors[0] }}</span>
                                  </ValidationProvider>
  
                                  <label for="phone">Telefono</label>
                                  <input type="text"
                                      class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                      name="phone" v-model="phone" />
                              </div>
                          </div>
                          <!-- Manager -->
                          <div class="mb-4 bg-white border rounded-md shadow-lg">
                              <div class="p-7">
                                  <h4 class="text-2xl font-semibold">Responsabile</h4>
                                  <div class="w-full my-6 border-b-2 border-gray-100"></div>
                                  <label for="name">Nome</label>
                                  <input type="text"
                                      class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                      name="manager_name" v-model="manager_name" />
  
                                  <label for="manager_last_name">cognome</label>
                                  <input type="text"
                                      class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                      name="manager_last_name" v-model="manager_last_name" />
  
                                  <ValidationProvider name="manager_email" rules="email_check" :bails="false"
                                      v-slot="{ classes, errors }">
                                      <label for="manager_email">Email</label>
                                      <input type="email"
                                          class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                          name="manager_email" v-model="manager_email" :class="classes" />
                                      <span class="text-xs font-bold error-notice">{{ errors[0] }}</span>
                                  </ValidationProvider>
  
                                  <label for="manager_phone">Telefono</label>
                                  <input type="text"
                                      class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                      name="manager_phone" v-model="manager_phone" />
                              </div>
                          </div>
  
  
                          <!-- social -->
                          <div class="mb-4 bg-white border rounded-md shadow-lg">
                              <div class="p-7">
                                  <h4 class="text-2xl font-semibold">Social</h4>
                                  <p class="text-xs text-gray-500">
                                      incollare link completo, ad esempio
                                      <br />https://www.facebook.com/OsmOpenSourceManagement/
                                  </p>
                                  <div class="w-full my-6 border-b-2 border-gray-100"></div>
  
                                  <label for="social_1">LinkedIn</label>
                                  <input type="text"
                                      class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                      placeholder="https://it.linkedin.com/" name="social_1" v-model="social_1" />
  
                                  <label for="social_2">Facebook</label>
                                  <input type="text"
                                      class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                      placeholder="https://www.facebook.com/" name="social_2" v-model="social_2" />
  
                                  <label for="social_3">Instagram</label>
                                  <input type="text"
                                      class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                      placeholder="https://www.instagram.com/" name="social_3" v-model="social_3" />
  
                                  <label for="social_4">YouTube</label>
                                  <input type="text"
                                      class="w-full p-2 mb-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                      placeholder="https://www.youtube.com/" name="social_4" v-model="social_4" />
                              </div>
                          </div>
  
                        
                          <!-- wallet -->
                          <!-- <div class="mb-4 bg-white border rounded-md shadow-lg">
                          <div class="p-7">
                              <h4 class="text-2xl font-semibold">Wallet Adress</h4>
                              <input type="text" class="w-full p-2 my-3 text-black bg-white border border-gray-300 rounded-md focus:outline-none" name="name" v-model="wallet_address" />
                          </div>
                      </div> -->
                      </div>
                      <!--second column end-->
                  </div>
                  <!-- error message for featuree and looking products -->
                  <div class="py-1 text-sm font-semibold text-center text-red-700">
                      {{ this.error }}
                  </div>
                  <!-- form submit button -->
                  <button type="submit" :disabled="!isComplete" :class="isComplete ? '' : 'opacity-50 cursor-not-allowed'"
                      class="w-full p-2 text-center text-white bg-green-500 border rounded-md">Salva azienda</button>
                      {{ message }}
                      <SuccessBanner v-show="successBanner" :message="message"></SuccessBanner>

              </form>
  
          </div>
      </customer-layout>
  
  </template>
  
  <style lang="css">
  @import "~vue2-editor/dist/vue2-editor.css";
  </style>
  
  <script>
  import { VueEditor } from "vue2-editor";
  import { ValidationProvider, extend } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules.umd.js';
  import { configure } from 'vee-validate';
  import axios from "axios";
  import CustomerLayout from '@/Layouts/CustomerLayout.vue';
  import SuccessBanner from "../../Components/PopUpBanner/Success.vue";
  import WarningBanner from "../../Components/PopUpBanner/Warning.vue";
  
  
  extend('required', {
      ...required,
      message: 'Questo campo è richiesto'
  });
  
  extend('email_check', {
      validate(value) {
          if ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) === false) {
              this.message = "Si prega di inserire un indirizzo email valido";
              return this.message;
          }
          return true;
  
      },
  });
  
  extend('check_vat', {
      params: ["limit"],
      validate(value, { limit }) {
          if (value.length < limit) {
              this.message = "La partita IVA deve essere composta da 11 caratteri";
              return this.message;
          }
          this.message = '';
          return true;
      },
  });
  
  configure({
      classes: {
          valid: 'is-valid',
          invalid: 'is-invalid',
          dirty: ['is-dirty', 'is-dirty'],
      }
  });
  
  
  export default {
      props: [ "region_id", "province_id",'user'],
      components: {
          VueEditor,
          ValidationProvider,
          WarningBanner,
          SuccessBanner,
          CustomerLayout,
      },
      data() {
          return {
              manager_name: null,
              warningBanner: false,
              successBanner: false,
              message: "",
                error: "",
              name: "",
              manager_last_name: null,
              p_iva: "",
              sdi_cod: "",
              site_url: "",
              email: "",
              manager_email: null,
              phone: "",
              manager_phone: null,
              mission: "",
              tag_name: "",
              address: "",
              branches: "",
              companyBranches: [],
              city: "",
              region: "",
              province: 0,
              zip_code: "",
              social_1: "",
              social_2: "",
              social_3: "",
              social_4: "",
              coverImagePreview: null,
              coverShowPreview: false,
              logoImagePreview: null,
              logoShowPreview: false,
              cover_image: null,
              logo: null,
              selectedOptions: [],
              completed: {
                  mbs_completed: false,
                  completed_message: null,
              },
              partner: {
                  mbs_osm_partner: false,
                  osm_partner_message: null,
              },
              progress: {
                  mbs_progress: false,
                  progress_message: null,
              },
              support: {
                  mbs_support_inss: false,
                  support_inss_message: null,
              },
        
               looks: [{
                  high_priority: false,
                  product: null,
              }],
              error: '',
              provinces: {},
              summary: '',
              limitMessage: '',
              messageImage: '',
              messageLogo: '',
              wallet_address: null,
              regions: this.region_id,
          };
      },
      computed: {
          isComplete() {
              if (this.p_iva.length == 11) {
                  return this.name && this.p_iva;
              }
          },
      },
      methods: {
          onCoverChange(event) {
              let custObj = this;
              this.cover_image = event.target.files[0];
              let reader = new FileReader();
              const file = this.$refs.file.files[0];
              if (file.size > 1024 * 1024) {
                  custObj.messageImage = 'File troppo grande (la dimensione massima del file caricato è 1 MB)'
                  return false;
              } else {
                  reader.addEventListener("load", function () {
                      this.coverShowPreview = true;
                      this.coverImagePreview = reader.result;
                  }.bind(this), false);
  
                  if (this.cover_image) {
                      if (/\.(jpe?g|gif|png|webp)$/i.test(this.cover_image.name)) {
                          reader.readAsDataURL(this.cover_image);
                      }
                      else {
                          custObj.messageImage = "Carica l'immagine in formato jpg o png o webp"
                          return false;
                      }
                  }
              }
          },
          onLogoChange(event) {
              let custObj = this;
              this.logo = event.target.files[0];
              let reader = new FileReader();
              const file = this.$refs.file1.files[0];
              if (file.size > 1024 * 1024) {
                  custObj.messageLogo = 'File troppo grande (la dimensione massima del file caricato è 1 MB)'
                  return false;
              } else {
                  reader.addEventListener("load", function () {
                      this.logoShowPreview = true;
                      this.logoImagePreview = reader.result;
                  }.bind(this), false);
  
                  if (this.logo) {
                      if (/\.(jpe?g|gif|png|webp)$/i.test(this.logo.name)) {
                          reader.readAsDataURL(this.logo);
                      }
                      else {
                          custObj.messageLogo = 'Carica il logo in formato jpg o png o webp'
                          return false;
                      }
                  }
              }
          },
          companySubmit(e) {
              e.preventDefault();
              this.error = '';
              let formData = new FormData();
  
              if (this.branches == true) {
                  if (this.companyBranches.length == 0) {
                      this.error = "Please add region or unchecked Filiali";
                      return false;
                  }
              } else {
                  this.companyBranches = [];
              }
              formData.append('companyBranches', this.companyBranches);
              formData.append('manager_name', this.manager_name);
              formData.append('manager_last_name', this.manager_last_name);
              formData.append('manager_email', this.manager_email);
              formData.append('manager_phone', this.manager_phone);
              formData.append('cover_image', this.cover_image);
              formData.append('name', this.name);
              formData.append('p_iva', this.p_iva);
              formData.append('sdi_cod', this.sdi_cod);
              formData.append('site_url', this.site_url);
              formData.append('email', this.email);
              formData.append('phone', this.phone);
              formData.append('mission', this.mission);
              formData.append('logo', this.logo);
              formData.append('address', this.address);
              formData.append('city', this.city);
              formData.append('region', this.region);
              formData.append('province', this.province);
              formData.append('zip_code', this.zip_code);
              formData.append('social_1', this.social_1);
              formData.append('social_2', this.social_2);
              formData.append('social_3', this.social_3);
              formData.append('social_4', this.social_4);
              formData.append('partner', JSON.stringify(this.partner));
              formData.append('progress', JSON.stringify(this.progress));
              formData.append('support', JSON.stringify(this.support));
              formData.append('summary', this.summary);
              formData.append('wallet_address', this.wallet_address);
              formData.append('user',this.user);
  
              const headers = {
                  'Content-Type': 'application/json'
              };
  
              // check for summary text limit
              if (this.summary.length <= 250) {           
                axios.post('/api/user/create-company', formData, { headers }).then(function (response) {
                    if (response.data.message == 'Nuova azienda aggiunta') {
                        window.location = '/dashboard'
                        // let newObj = this;

                        // newObj.successBanner = true;

                        // newObj.message = response.data.message;
                        //     setTimeout(() => {
                        //         newObj.successBanner = false
                        //     }, 1000)
                    } else {
                        this.error = response.data.message;
                    }
                }).catch(function (error) {
                });
            }
               else {
                  this.error = "Il riepilogo non può superare i 250 caratteri.";
              }
          },
     
          addLooks() {
              this.looks.push({ high_priority: false, product: null });
          },
          removeLooks(value) {
              this.looks.splice(value, 1);
          },
          filterProvince(value) {
              var regionId = value;
              var array = [];
              this.province_id.forEach((value, index) => {
                  if (value.region_id === regionId) {
                      array.push(value);
                  }
              });
              this.provinces = array;
          },
          NumbersOnly(evt) {
              evt = (evt) ? evt : window.event;
              var charCode = (evt.which) ? evt.which : evt.keyCode;
              if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                  evt.preventDefault();
              } else {
                  return false;
              }
          },
          textLimit(e) {
              let testData = this.summary;
              let dataFilter = testData.replace(/<\/?[^>]+(>|$)/g, '');
              let len = dataFilter.length;
              if (len >= 250 && e.key !== 'Backspace') {
                  e.preventDefault();
                  this.limitMessage = 'Il riepilogo non può superare i 250 caratteri.';
              }
              if (e.key == 'Backspace') {
                  this.limitMessage = '';
              }
          }
      }
  };
  </script>
  
  <style scoped>
  div.passed,
  input.passed,
  select.changed {
      background-color: #d6eebc;
  }
  
  div.extra.passed {
      border: 1px solid #7ED321;
  }
  
  div.failed,
  input.failed,
  select.failed {
      background-color: #e35e74;
  }
  
  div.extra.failed {
      border: 1px solid #D0021B;
  }
  
  span.error-notice {
      color: #D0021B;
      display: block;
  }
  </style>